import blend from './blend';
import rgba from './rgba';
import LIGHT from './light';
import DARK from './dark';

declare global {
  interface Window {
    __config__: any;
  }
}

let THEME = DARK;
try {
  THEME = window.__config__?.theme === 'light' ? LIGHT : DARK;
} catch (e) {
  // ignore
}

function getBackgroundForTheme(theme: 'dark' | 'light') {
  return theme === 'dark' ? DARK.background : LIGHT.background;
}

export { LIGHT, DARK, THEME, rgba, blend, getBackgroundForTheme };
